import { Suspense, lazy } from 'react';

import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = <T extends React.ComponentType<any>>(
  importComponent: () => Promise<{ default: T }>,
) => {
  const LazyComponent = lazy(
    // @ts-ignore
    async () => {
      try {
        return await importComponent();
      } catch (error: any) {
        console.error('dynamic import failed: ', { error });
        // Check if the error is specifically a failed dynamic import
        if (error?.message.includes('Failed to fetch dynamically imported module')) {
          // Trigger a page refresh
          window.location.reload();
        }
        throw error; // re-throw the error if it's not a chunk error
      }
    },
  );

  return (props: React.ComponentProps<T>) => (
    <Suspense fallback={<Loader />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default Loadable;
